import React, { useEffect } from 'react';
import styles from '../css/Acordeon.module.scss'

export const Acordeon = ({ items }) => {

    return (
        <div class={"accordion my-5 " + styles.acordeon} id="accordionPorQue">

            {items.map(function (elem, i) {
                return (
                    <div class="accordion-item ">
                        <h2 class="accordion-header" id={"heading" + i}>
                            <button class={"accordion-button " + styles.acordeonBtn + (i !== 0 ? ' collapsed' : '')} type="button" data-bs-toggle="collapse" data-bs-target={"#collapse" + i}
                                aria-expanded={i === 0} aria-controls={"collapse" + i}>
                                {elem.titulo}
                            </button>
                        </h2>
                        <div id={"collapse" + i} class={"accordion-collapse collapse " + (i === 0 ? 'show' : '')} aria-labelledby={"heading" + i} data-bs-parent="#accordionPorQue">
                            <div class="accordion-body">
                                {elem.descripcion}
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )

}
